import { OpenAPI } from "./SolarCloudApi/core/OpenAPI";
import { request as __request } from "./SolarCloudApi/core/request";
import { CancelablePromise } from "./SolarCloudApi/core/CancelablePromise";

export type ManualPaymentRequestResponse = {
    requestId: string;
    orderUuid: string;
    orderNumber: string;
    amount: number;
    currency: string;
    state: string;
    paymentMethodType: string;
    expiresAt: string;
    order?: any;
};

export type ManualPaymentConfirmationResponse = ManualPaymentRequestResponse & {
    confirmed: boolean;
    paymentStatus: string;
    sessionStatus: string;
};

export type ManualStripeIntentResponse = {
    clientSecret: string;
    amount: number;
    paymentIntentId: string;
};

export type ManualPayPalCreateResponse = {
    id: string;
};

export type ManualMintPaymentRequest = {
    number: string;
    holderName: string;
    expiryMonth: string;
    expiryYear: string;
    cvc: string;
};

export class ManualPaymentService {
    public static resolveToken(token: string): CancelablePromise<ManualPaymentRequestResponse> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/api/orders/payment/manual/resolve",
            query: {
                token: token,
            },
        });
    }

    public static getRequestByUuid(requestUuid: string): CancelablePromise<ManualPaymentRequestResponse> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/api/orders/payment/manual/{requestUuid}",
            path: {
                requestUuid: requestUuid,
            },
        });
    }

    public static createSession(requestUuid: string, token?: string): CancelablePromise<{ checkoutUrl: string }> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/api/orders/payment/manual/{requestUuid}/checkout-session",
            path: {
                requestUuid: requestUuid,
            },
            query: {
                token: token,
            },
        });
    }

    public static createStripeIntent(requestUuid: string, token?: string, paymentMethod?: string): CancelablePromise<ManualStripeIntentResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/api/orders/payment/manual/{requestUuid}/stripe/create",
            path: {
                requestUuid: requestUuid,
            },
            query: {
                token: token,
            },
            body: paymentMethod ? { paymentMethod } : undefined,
        });
    }

    public static completeStripeIntent(requestUuid: string, paymentIntentId: string, token?: string): CancelablePromise<ManualPaymentConfirmationResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/api/orders/payment/manual/{requestUuid}/stripe/complete",
            path: {
                requestUuid: requestUuid,
            },
            query: {
                paymentIntentId: paymentIntentId,
                token: token,
            },
        });
    }

    public static createPaypalOrder(requestUuid: string, token?: string): CancelablePromise<ManualPayPalCreateResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/api/orders/payment/manual/{requestUuid}/paypal/create",
            path: {
                requestUuid: requestUuid,
            },
            query: {
                token: token,
            },
        });
    }

    public static capturePaypalOrder(requestUuid: string, paypalOrderId: string, token?: string): CancelablePromise<ManualPaymentConfirmationResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/api/orders/payment/manual/{requestUuid}/paypal/capture",
            path: {
                requestUuid: requestUuid,
            },
            query: {
                paypalOrderId: paypalOrderId,
                token: token,
            },
        });
    }

    public static submitMintPayment(requestUuid: string, payment: ManualMintPaymentRequest, token?: string): CancelablePromise<ManualPaymentConfirmationResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/api/orders/payment/manual/{requestUuid}/mint/pay",
            path: {
                requestUuid: requestUuid,
            },
            query: {
                token: token,
            },
            body: payment,
        });
    }

    public static confirmSession(sessionId: string): CancelablePromise<ManualPaymentConfirmationResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/api/orders/payment/manual/confirm-session",
            query: {
                session_id: sessionId,
            },
        });
    }
}
